import { motion } from "framer-motion";
import { CalendarDays, Sun, Snowflake, Flower2, Info } from "lucide-react";

const terms = [
  { label: "Autumn · Term 1", range: "Mon 7 Sep – Sun 25 Oct", icon: <Sun size={18} />, accent: "#F59E0B" },
  { label: "Autumn · Term 2", range: "Mon 2 Nov – Sun 13 Dec", icon: <Sun size={18} />, accent: "#FF7A1A" },
  { label: "Spring · Term 1", range: "Mon 4 Jan – Sun 14 Feb", icon: <Snowflake size={18} />, accent: "#0EA5E9" },
  { label: "Spring · Term 2", range: "Mon 22 Feb – Sat 27 Mar", icon: <Flower2 size={18} />, accent: "#1F7A8C" },
  { label: "Summer · Term 1", range: "Sun 11 Apr – Sun 30 May", icon: <Flower2 size={18} />, accent: "#10B981" },
  { label: "Summer · Term 2", range: "Mon 7 Jun – Sun 18 Jul", icon: <Sun size={18} />, accent: "#14B8A6" },
];

export default function TermDates() {
  return (
    <section className="py-24 md:py-28 bg-[#0A2540] text-white overflow-hidden" data-testid="term-dates-section">
      <div className="container mx-auto px-6 md:px-12">
        <div className="max-w-2xl mb-12">
          <span className="inline-flex items-center gap-2 text-sm text-[#38BDF8] tracking-[0.2em] uppercase font-bold">
            <CalendarDays size={16} /> When we swim
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight leading-tight">
            Our term dates
          </h2>
          <p className="mt-5 text-lg text-white/70">
            We run classes across six friendly terms throughout the year in our warm 31–33°C pool. These dates are here to help our members plan ahead — so you always know exactly when we're splashing and when we take a little breather between terms.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {terms.map((t, i) => (
            <motion.div
              key={t.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="group relative rounded-[1.75rem] bg-white/[0.06] border border-white/10 p-6 hover:bg-white/[0.1] hover:-translate-y-1 transition-all duration-500 overflow-hidden"
              data-testid={`term-card-${i}`}
            >
              <div
                className="absolute -right-6 -top-6 w-24 h-24 rounded-full blur-2xl opacity-30 group-hover:opacity-50 transition-opacity"
                style={{ backgroundColor: t.accent }}
              />
              <div className="relative flex items-center gap-3">
                <span
                  className="grid place-items-center w-11 h-11 rounded-2xl text-white shrink-0"
                  style={{ backgroundColor: t.accent }}
                >
                  {t.icon}
                </span>
                <span className="text-xs font-bold uppercase tracking-wider text-white/60">{t.label}</span>
              </div>
              <p className="relative mt-5 font-heading text-xl md:text-2xl font-bold leading-tight">{t.range}</p>
            </motion.div>
          ))}
        </div>

        <p className="mt-8 flex items-center gap-2 text-sm text-white/50" data-testid="term-dates-disclaimer">
          <Info size={15} /> Dates are subject to change.
        </p>
      </div>
    </section>
  );
}
